
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/well/[param]/[month]/[day]/[slug]",
      function () {
        return require("private-next-pages/well/[param]/[month]/[day]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/well/[param]/[month]/[day]/[slug]"])
      });
    }
  